/**
 * TODO: migrate to develop branch
 * extension page register:
 * - <DiningKioskHPage />
 * - <DiningPage />
 * ... more in `src\StandardApp.js`
 */
import { Directory } from "pages/directory"
import { Events } from "pages/events"
import { EventDetail } from "pages/events/[eventId]"
import { Promotions } from "pages/promotions"
import { PromotionDetail } from "pages/promotions/[promotionId]"
import { DiningKioskHPage } from "extensions/em-core/pages/dining/index.kiosk"
import { EventsKioskHPage } from "pages/events/index.kiosk"
import { EventDetailKioskHPage } from "pages/events/[eventId].kiosk"
import { PromotionsKioskHPage } from "pages/promotions/index.kiosk"
import { PromotionDetailKioskHPage } from "pages/promotions/[promotionId].kiosk"
import { OccupantPromotionKioskHPage } from "pages/promotions/occupant/[occupantId].kiosk"
import { DirectoryKioskHPage } from "pages/directory/index.kiosk"
import { NewShopsKioskHPage } from "pages/new-shops/index.kiosk"

import { NewShops } from "pages/new-shops"
import { ContentWithAside } from "layouts/kiosk-h"
import { DiningPage } from "extensions/em-core/pages/dining"

// Standard routes
export const standardRoutes = {
  mobile: [
    { path: "events", element: <Events /> },
    { path: "events/:eventId", element: <EventDetail /> },
    { path: "promotions", element: <Promotions /> },
    { path: "promotions/:promotionId", element: <PromotionDetail /> },
    { path: "directory", element: <Directory /> },
    { path: "new-shops", element: <NewShops /> },
    { path: "dining", element: <DiningPage /> },
  ],
  "kiosk-h": [
    { path: "events", element: <EventsKioskHPage Layout={ContentWithAside} /> },
    {
      path: "events/:eventId",
      element: <EventDetailKioskHPage Layout={ContentWithAside} />,
    },
    {
      path: "promotions",
      element: <PromotionsKioskHPage Layout={ContentWithAside} />,
    },
    {
      path: "promotions/occupant/:occupantId",
      element: <OccupantPromotionKioskHPage Layout={ContentWithAside} />,
    },
    {
      path: "promotions/:promotionId",
      element: <PromotionDetailKioskHPage Layout={ContentWithAside} />,
    },
    {
      path: "directory",
      element: <DirectoryKioskHPage Layout={ContentWithAside} />,
    },
    {
      path: "new-shops",
      element: <NewShopsKioskHPage Layout={ContentWithAside} />,
    },
    { path: "dining", element: <DiningKioskHPage Layout={ContentWithAside} /> },
  ],
  "kiosk-v": [
    //TODO:: update to kiosk-v version later
    { path: "events", element: <Events /> },
    { path: "events/:eventId", element: <EventDetail /> },
    { path: "promotions", element: <Promotions /> },
    { path: "promotions/:promotionId", element: <PromotionDetail /> },
    { path: "directory", element: <Directory /> },
    { path: "new-shops", element: <NewShops /> },
    { path: "dining", element: <DiningPage /> },
  ],
}
